import { render, staticRenderFns } from "./config-new.vue?vue&type=template&id=3bd2004c&"
import script from "./config-new.vue?vue&type=script&lang=js&"
export * from "./config-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports